import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { STATUS_OPTIONS } from './utils';

export const StatusCell = ({ value, onChange, readOnly }) => {
  const [editing, setEditing] = useState(false);
  const [customVal, setCustomVal] = useState('');

  if (readOnly) {
    return <span className="text-xs px-1.5">{value || ''}</span>;
  }

  if (editing) {
    return (
      <div className="space-y-1">
        <div className="flex flex-wrap gap-1">
          {STATUS_OPTIONS.map(s => (
            <button
              key={s}
              onClick={() => { onChange(s); setEditing(false); }}
              className={`text-[10px] px-2 py-0.5 rounded-full border transition-colors ${
                value === s
                  ? 'bg-[#2d948c] text-white border-[#2d948c]'
                  : 'bg-white hover:bg-[#2d948c]/10 border-border'
              }`}
              data-testid={`status-option-${s.toLowerCase().replace(/\s/g, '-')}`}
            >
              {s}
            </button>
          ))}
        </div>
        <div className="flex gap-1">
          <Input
            value={customVal}
            onChange={e => setCustomVal(e.target.value)}
            placeholder="Custom status..."
            className="h-6 text-[10px] px-1.5"
            onKeyDown={e => {
              if (e.key === 'Enter' && customVal.trim()) {
                onChange(customVal.trim());
                setCustomVal('');
                setEditing(false);
              }
            }}
            data-testid="custom-status-input"
          />
        </div>
        <button onClick={() => setEditing(false)} className="text-[10px] text-[#5b6773] underline">close</button>
      </div>
    );
  }

  const statusColor = {
    'Delivered': 'bg-[#2f7d5a]/10 text-[#2f7d5a]',
    'Ordered': 'bg-[#2f6f8f]/10 text-[#2f6f8f]',
    'Pending': 'bg-[#d97706]/10 text-[#d97706]',
    'Confirmed': 'bg-[#2d948c]/10 text-[#2d948c]',
    'Returned': 'bg-destructive/10 text-destructive',
  }[value] || 'bg-[#5b6773]/10 text-[#5b6773]';

  return (
    <span
      onClick={() => setEditing(true)}
      className={`inline-block text-[10px] px-2 py-0.5 rounded-full cursor-pointer hover:ring-1 hover:ring-[#2d948c] transition-all ${value ? statusColor : 'text-[#5b6773]/40 italic'}`}
      data-testid="status-badge"
    >
      {value || 'Set status'}
    </span>
  );
};
